interface GetIsSmartCodeUrlPublishSwitchShownProps {
  isSmartCodeUrlPublishSwitchShown?: boolean;
}

export const getIsSmartCodeUrlPublishSwitchShown = (
  props: GetIsSmartCodeUrlPublishSwitchShownProps
): boolean => props.isSmartCodeUrlPublishSwitchShown !== false;
